import React from 'react';
import { Controller } from 'react-hook-form';
import YesNoQuestion, {
    YesNoState,
} from '@alfa-retail-react/components/yes-no-question';
import { observer } from 'mobx-react';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { Section } from 'app/component/Section';
import { SoleOwnerForm } from 'app/logic/pages/employment/SoleOwnerForm';
import { EmploymentFormValues } from 'app/logic/pages/employment/EmploymentPage';
import { EmploymentPageStore } from 'app/logic/pages/employment/EmploymentPageStore';
import { ValidationRules } from 'app/form/ValidationRules';

export interface SoleOwnerFormSectionProps {
    pageStore: EmploymentPageStore;
}

export const SoleOwnerFormSection = observer(
    ({ pageStore }: SoleOwnerFormSectionProps) => {
        const { formStore } = pageStore;
        const { control, handleMultipleErrors } =
            useFormContext<EmploymentFormValues>();

        return (
            <Section
                className={'soleOwnerFormSection'}
                title={'Кредитная анкета'}
                content={
                    <>
                        <Controller<EmploymentFormValues>
                            defaultValue={formStore.soleOwner}
                            control={control}
                            name={'soleOwner'}
                            rules={{ required: ValidationRules.required() }}
                            render={({ field, fieldState }) => {
                                return (
                                    <YesNoQuestion
                                        ref={field.ref}
                                        className={'soleOwnerQuestion'}
                                        question={
                                            'Являетесь ли вы по основному виду деятельности ИП, работником ИП, адвокатом, нотариусом или неработающим пенсионером, самозанятым?'
                                        }
                                        error={handleMultipleErrors(
                                            fieldState.error,
                                        )}
                                        value={formStore.soleOwner}
                                        fields={[
                                            {
                                                key: YesNoState.YES,
                                                title: 'Да',
                                            },
                                            {
                                                key: YesNoState.NO,
                                                title: 'Нет',
                                            },
                                        ]}
                                        onChange={(event, value) => {
                                            field.onChange(value);
                                            formStore.setSoleOwner(value);
                                        }}
                                    />
                                );
                            }}
                        />

                        {formStore.soleOwner === YesNoState.YES && (
                            <SoleOwnerForm formStore={formStore} />
                        )}
                    </>
                }
            />
        );
    },
);
